import { clsx, type ClassValue } from 'clsx'
import { toast } from 'sonner'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const copyToClipboard = async (
  text: string,
  successMessage = 'Meeting link copied to clipboard'
): Promise<boolean> => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text)
      toast.success(successMessage, { closeButton: false })
      return true
    }

    const textArea = document.createElement('textarea')
    textArea.value = text
    document.body.appendChild(textArea)
    textArea.select()

    document.execCommand('copy')
    document.body.removeChild(textArea)

    toast.success(successMessage)
    return true
  } catch (err) {
    console.error('Copy failed:', err)
    toast.error('Failed to copy text')
    return false
  }
}

export const getBaseUrl = (url: string) => {
  try {
    const { origin } = new URL(url)
    return origin
  } catch (error) {
    console.error('Invalid URL:', url)
    return ''
  }
}

export const getAudioTrackSid = (trackPublications: Map<string, any>) => {
  for (const [key, publication] of trackPublications) {
    if (publication.kind === 'audio') {
      return key
    }
  }
  return null
}
